import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectMutationKeys } from '../constants'
import { getUserId } from '../../authentication/query/use-me-query'

export const useCheckProjectChildrenNameIsAvailableMutation = (options) => {
  const handleMutation = async ({
    destinationFolderId = null,
    selectedItemNames,
    expand = ''
  }) => {
    const userId = getUserId()

    const getRootFolderId = async () => {
      const { data } = await api(
        `/api/v2/projectFolders/root?userId=${userId}&expand=${expand}`,
        {
          method: 'get'
        }
      )

      return data.id
    }

    const folderId = destinationFolderId ?? (await getRootFolderId())

    const config = {
      method: 'post',
      data: selectedItemNames
    }

    const { data } = await api(
      `/api/v2/projectFolders/${folderId}/childrenNames`,
      config
    )

    return data
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: projectMutationKeys.CHECK_CHILDREN_NAME_IS_AVAILABLE,
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      return options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      return options?.onError?.(error, variables, context)
    }
  })
}
